// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falCheck: CreateIconOptions = {
  "displayName": "FALCheck",
  "viewBox": "0, 0, 448, 512",
  "d": "M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z"
};
